import React from 'react'

interface InflectionLogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

/**
 * Inflection Medicine logo component (COEP credentialless allows cross-origin).
 */
export const InflectionLogo: React.FC<InflectionLogoProps> = ({ className = '', size = 'md' }) => {
  const heightClasses = {
    sm: 'max-h-6',
    md: 'max-h-8',
    lg: 'max-h-12',
  }

  return (
    <img
      src="/icons/Inflection_Logo_Dark_LG.png"
      alt="Inflection Medicine"
      className={`h-auto w-auto max-w-full object-contain ${heightClasses[size]} ${className}`}
    />
  )
}

export default InflectionLogo
